export enum SortButtonDirection {
	unset = 'unset',
	ascending = 'ascending',
	descending = 'descending',
}
